import axios from "axios";

export default {
  async create(formData) {
    return axios.post(`/rent-object-beds/rent-objects/${formData.rentObjectId}`, formData);
  },
  async findAll(formData) {
    return axios.get(`/rent-object-beds/rent-objects/${formData.rentObjectId}`);
  },
  async update(formData) {
    return axios.put('/rent-object-beds', formData);
  },
  async delete({ id }) {
    return axios.delete(`/rent-object-beds/${id}`);
  },
};
